<script>
import BaseIcon from "@/components/Base/Elements/BaseIcon";

export default {
  name: "Icon",
  extends: BaseIcon
};
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";

.icon-asterisk {
  top: -0.3em;
  left: -0.2em;
  width: 0.7em;
}

.icon-question-circle {
  fill: $col-primary;
}
</style>
